import { render, staticRenderFns } from "./schemeView.vue?vue&type=template&id=f8dd02d2&scoped=true"
import script from "./schemeView.vue?vue&type=script&lang=js"
export * from "./schemeView.vue?vue&type=script&lang=js"
import style0 from "./schemeView.vue?vue&type=style&index=0&id=f8dd02d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dd02d2",
  null
  
)

export default component.exports